module.exports = __webpack_public_path__ + "img/流汗.47556db7.gif";